import { Box, CircularProgress } from '@material-ui/core';
// import {connect} from 'react-redux';
import dayjs from 'dayjs';
import React from 'react';
import downloadCSVIcon from '../../../../assets/CSV.png';
import { localized } from '../../../../state/i18n/i18n';
import { GetColorByIndex } from '../../../../utilities/colors';
import { DownloadButton } from '../../default-components/download-button/download-button';
import { GraphLegend } from '../../default-components/graph-legend/graph-legend';
import { LineChart } from '../../default-components/line-chart/line-chart';
import { RadioButtonGroup } from '../../default-components/radio-button-group/radio-button-group';
import './style.scss';

const availableTypes = {
  [localized('Battery')]: localized('BatteryValue'),
  [localized('Temperature')]: localized('TemperatureValue'),
  [localized('WaterLevel')]: localized('WaterLevelValue'),
};

const getKeyFromType = (key) => {
  switch (key) {
    case localized('Battery'):
      return 'batteryVoltage';
    case localized('Temperature'):
      return 'waterTemp';
    default:
      return 'waterLevel';
  }
};

const getLabelYFromType = (key) => {
  switch (key) {
    case localized('Battery'):
      return localized('volts');
    case localized('Temperature'):
      return localized('celsius');
    default:
      return localized('m');
  }
};

const getDefault = (val) => {
  if (val === null) return '(empty)';
  return val;
};

const exportToCsv = (filename, rows, headers) => {
  var processRow = function (row) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null ? '' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      }
      var result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
      if (j > 0) finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = headers.join(',') + '\n';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'});
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

class DeviceGraph extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: localized('Battery'),
      downloading: false,
    };
  }

  downloadCSV = async () => {
    const {devicesData} = this.props;
    const rawRows = Object.values(devicesData).reduce((a, b) => a.concat(b), []);

    const headers = [
      'Device name',
      'Measurement time',
      'Message type',
      'Battery voltage',
      'Water temp.',
      'Water level',
    ];
    const rows = rawRows.map((item) => {
      const measureTime = dayjs(item.measurementTime).format('DD-MM-YYYY HH:mm:ss');
      return [
        item.deviceId,
        measureTime,
        item.messageType,
        getDefault(item.batteryVoltage),
        getDefault(item.waterTemp),
        getDefault(item.waterLevel),
      ];
    });
    exportToCsv('devices.csv', rows, headers);
  };

  render() {
    return (
      <div>
        {this.GetDeviceGraphContentWeb()}
        {this.GetDeviceGraphContentApp()}
      </div>
    );
  }

  GetDeviceTopHeaderApp = () => (
    <div className="flexWrap padding">
      <div className="flexDirectionRow appButtonTypes">{this.GetRadioButtonGroup()}</div>
      <div className="flexDirectionRow flexWrap deviceLegend">{this.mapDeviceLegends()}</div>
    </div>
  );

  GetRadioButtonGroup = () => (
    <RadioButtonGroup
      defaultValue={localized('Battery')}
      onChange={this.SetSelected}
      values={Object.keys(availableTypes)}
    />
  );

  GetDeviceTopHeaderWeb = () => (
    <div className="flexDirectionRow alignItemsCenter flexWrap legendsContainer ">
      <Box flexDirection="row" display="flex" className="legendsTab">
        <Box>{this.GetRadioButtonGroup()}</Box>
        <Box className="deviceLegend" flexDirection="row">
          {this.mapDeviceLegends()}
        </Box>
        <Box>
          <DownloadButton
            icon={
              <div className="paddingRight">
                <div>{this.state.downloading && <CircularProgress className="spinnerGraph" />}</div>
                <img
                  src={downloadCSVIcon}
                  className={
                    'downloadCSVIcon ' +
                    (this.state.downloading ? localized('Downloading') : localized('NotDownloading'))
                  }
                  alt="downloadCSVIcon"
                />
              </div>
            }
            text={'Download CSV'}
            onClick={this.downloadCSV}
            className="downloadCSV"
          />
        </Box>
      </Box>
    </div>
  );

  GetDeviceGraphContentApp = () => (
    <div className="mobile">
      {this.GetDeviceTopHeaderApp()}
      {this.getLineChart()}
    </div>
  );

  GetDeviceGraphContentWeb = () => (
    <div className="desktop graphWidth">
      {this.GetDeviceTopHeaderWeb()}
      {this.getLineChart()}
    </div>
  );

  SetSelected = (e) => {
    if (e && e.target && e.target.value) {
      this.setState({selected: e.target.value});
    }
  };

  getLineChart = () => (
    <LineChart
      scaleLabelY={availableTypes[this.state.selected]}
      scaleY={getLabelYFromType(this.state.selected)}
      scaleLabelX={localized('Date')}
      suggestedMinYValue={0}
      suggestedMaxYValue={5}
      minDate={this.props.dateFrom}
      maxDate={this.props.dateTo}
      data={this.mapDevices()}
    />
  );

  mapDeviceLegends = () => {
    const {devices} = this.props;
    if (!Array.isArray(devices)) return;
    return devices.map((d, index) => (
      <GraphLegend key={d.deviceId} text={d.deviceId ? d.deviceId : ''} color={GetColorByIndex(index)} />
    ));
  };

  mapDevices = () => {
    const {devices, devicesData} = this.props;
    if (!Array.isArray(devices)) return [];

    return devices.map((d, index) => {
      const data = devicesData[d.deviceId] || [];
      return {
        colorTheme: GetColorByIndex(index),
        name: d.deviceId,
        data: d.selected
          ? data
              .sort((a, b) => {
                return a.measurementTime - b.measurementTime;
              })
              .map((a) => {
                return {
                  t: new Date(a.measurementTime),
                  y: a[getKeyFromType(this.state.selected)],
                };
              })
          : [],
      };
    });
  };
}

export default DeviceGraph;
